import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Mapa from './pages/Mapa';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import DetalheEmpreendimento from './pages/DetalheEmpreendimento'; 

// 👇 CORREÇÃO: O nome agora é apenas 'token' (igual ao Login.jsx)
const RotaProtegida = ({ children }) => {
  const token = localStorage.getItem('token'); 
  return token ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <div className="app-container font-sans text-gray-700">
      <Routes>
        <Route path="/" element={<Mapa />} />
        <Route path="/login" element={<Login />} />
        
        {/* Detalhes da Obra */}
        <Route path="/empreendimento/:id" element={<DetalheEmpreendimento />} />

        {/* ✅ ROTA EXPLÍCITA DE ERRO (Para quando o código faz navigate('/404')) */}
        <Route path="/404" element={<NotFound />} />

        {/* Curinga (Qualquer outra coisa cai aqui) */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;